import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.featured-posts' ).length ) {
        $( '.featured-posts' ).each( function( index, element ) {
          const slideCount = element.querySelectorAll( '.splide__slide' ).length;
          const hasEnough = slideCount >= 3;

          const slider = new Splide( element, {
            type: hasEnough ? 'loop' : 'slide',
            gap: '12px',
            perMove: 1,
            perPage: 4,
            pagination: false,
            speed: 800,
            fixedWidth: '369px',
            arrows: hasEnough,
            drag: hasEnough,
            breakpoints: {
              768: {
                perPage: 1,
                fixedWidth: false,
                arrows: slideCount > 1,
                drag: true,
              },
            },
          } );

          slider.mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'featured-posts', COMPONENT );
} )( app );
